/* tslint:disable */
/* eslint-disable */

import { exists } from '../runtime';
import type { ControlLargeMarketClientSearchResult } from './ControlLargeMarketClientSearchResult';
import {
    ControlLargeMarketClientSearchResultFromJSON,
    ControlLargeMarketClientSearchResultToJSON,
} from './ControlLargeMarketClientSearchResult';

/**
 * @export
 * @interface ControlLargeMarketClientSearchResponse
 */
export interface ControlLargeMarketClientSearchResponse {
    results?: Array<ControlLargeMarketClientSearchResult>;
    page: number;
    page_size: number;
    count: number;
}

export function ControlLargeMarketClientSearchResponseFromJSON(
    json: any,
): ControlLargeMarketClientSearchResponse {
    return ControlLargeMarketClientSearchResponseFromJSONTyped(json, false);
}

export function ControlLargeMarketClientSearchResponseFromJSONTyped(
    json: any,
    _ignoreDiscriminator: boolean,
): ControlLargeMarketClientSearchResponse {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        results: !exists(json, 'results')
            ? undefined
            : (json['results'] as Array<any>).map(
                ControlLargeMarketClientSearchResultFromJSON,
              ),
        page: json['page'],
        page_size: json['page_size'],
        count: json['count'],
    };
}

export function ControlLargeMarketClientSearchResponseToJSON(
    value?: ControlLargeMarketClientSearchResponse | null,
): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        results:
            value.results === undefined
                ? undefined
                : (value.results as Array<any>).map(
                    ControlLargeMarketClientSearchResultToJSON,
                  ),
        page: value.page,
        page_size: value.page_size,
        count: value.count,
    };
}
